import React from 'react';
import { Button } from "react-bootstrap";
import { FaFileExport } from "react-icons/fa";
import Swal from "sweetalert2";
import * as XLSX from 'xlsx';
import * as LegacyTaskModels from '../../models/report/LegacyTask'
import { formatYMDToDMY } from "../modules/Common";

type Props = {
    jobStartedOnFrom: string;
    jobStartedOnTo: string;
};

export default function ExportToExcelButton(props: Props) {
    const { jobStartedOnFrom, jobStartedOnTo } = props;

    const handleClickExportToExcel = async () => {
        if (!jobStartedOnFrom || !jobStartedOnFrom) {
            Swal.fire({
                title: 'ไม่สำเร็จ',
                text: 'กรุณาเลือกวันที่',
                icon: 'error',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'ตกลง',
                allowOutsideClick: false
            });

            return;
        }

        const queryString = new URLSearchParams({
            job_started_on_from: jobStartedOnFrom,
            job_started_on_to: jobStartedOnTo,
        }).toString();

        const response = await fetch(`/v1/legacy/task?${queryString}`, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('LG_APPLICATION'),
            },
        });
        if (!response.ok) {
            Swal.fire({
                title: 'ไม่สำเร็จ',
                text: 'เกิดข้อผิดพลาดในการดึงข้อมูล',
                icon: 'error',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'ตกลง',
                allowOutsideClick: false
            });

            return;
        }

        const data = await response.json();
        const tasks: LegacyTaskModels.LegacyTask[] | null =
            data.result_list;
        if (!tasks || tasks.length === 0) {
            Swal.fire({
                title: 'ไม่สำเร็จ',
                text: 'ไม่พบข้อมูล',
                icon: 'error',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'ตกลง',
                allowOutsideClick: false
            });

            return;
        }

        const heads = [
            'รายงาน',
            'Company Code',
            'Legacy ID',
            'Legacy Name',
            'Job Instanceno',
            'Status (lastest)',
            'Job Start',
            'Job Finished On',
            'Load Files Status',
            'Load Files started on',
            'Conversion Status',
            'Call Function Status',
            'Call Function started on',
            'Return Files Status',
            'Return Files started on',
            'Function status',
            'Message'
        ];
        const rows = tasks.map((task, index) => [
            String(index + 1),
            task.companycode,
            task.legacyid,
            task.legacyname,
            task.job_instanceno,
            task.status,
            formatYMDToDMY(task.job_started_on),
            formatYMDToDMY(task.job_finished_on),
            task.step1_status,
            formatYMDToDMY(task.step1_started_on),
            task.step5_status,
            task.step2_status,
            task.step2_started_on,
            task.step3_status,
            task.step3_started_on,
            task.step4_status,
            task.message
        ]);
        const sheetData = [
            heads,
            ...rows
        ];

        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Lagacy Tasks');

        const fromDateString = jobStartedOnFrom.slice(0, 8);
        const toDateString = jobStartedOnTo.slice(0, 8);
        const fileName = `legacy_tasks_${fromDateString}_to_${toDateString}.xlsx`;

        XLSX.writeFile(workbook, fileName);
    }

    return (
        <Button
            variant="success"
            size="sm"
            style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
            className="mx-1 px-3 btn"
            onClick={handleClickExportToExcel}
        >
            <FaFileExport /> Export
        </Button>
    );
}